import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { Building2, ClipboardList, Handshake, History, LayoutDashboard, Lock, Radar, Users } from "lucide-react";
import api from "@/lib/api";

const TABS = [
  { to: "/crm/tableau-de-bord", label: "Tableau de bord", icon: LayoutDashboard, testid: "crm-nav-dashboard" },
  { to: "/crm/entreprises", label: "Entreprises", icon: Building2, testid: "crm-nav-companies" },
  { to: "/crm/contacts", label: "Contacts", icon: Users, testid: "crm-nav-contacts" },
  { to: "/crm/leads", label: "Leads", icon: Radar, testid: "crm-nav-leads" },
  { to: "/crm/opportunites", label: "Opportunités", icon: Handshake, testid: "crm-nav-opportunities" },
  { to: "/crm/activites", label: "Activités", icon: History, testid: "crm-nav-activities" },
  { to: "/crm/taches", label: "Tâches", icon: ClipboardList, testid: "crm-nav-tasks" },
];

export default function CrmLayout() {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    api.get("/auth/me")
      .then(({ data }) => {
        if (data.role !== "admin") return navigate("/admin", { replace: true });
        setEmail(data.email);
        setChecked(true);
      })
      .catch(() => navigate("/admin", { replace: true }));
  }, [navigate]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    navigate("/admin", { replace: true });
  };

  if (!checked) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-paper" data-testid="crm-loading">
        <Lock size={20} className="animate-pulse text-steel" />
      </main>
    );
  }

  return (
    <div className="flex min-h-screen bg-paper" data-testid="crm-layout">
      <aside className="fixed inset-y-0 left-0 z-30 flex w-64 flex-col border-r border-line bg-white">
        <div className="flex h-[76px] items-center border-b border-line px-6">
          <Link to="/" data-testid="crm-back-site" className="text-[13px] font-bold uppercase tracking-wider text-steel transition-colors hover:text-electric">
            ← EMP · CRM
          </Link>
        </div>
        <nav className="flex-1 space-y-1 overflow-y-auto p-4" aria-label="Navigation CRM">
          {TABS.map(({ to, label, icon: Icon, testid }) => (
            <NavLink key={to} to={to} data-testid={testid}
              className={({ isActive }) => `flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors ${isActive ? "bg-navy-800 text-white" : "text-graphite hover:bg-paper hover:text-electric"}`}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-line p-4">
          <p className="truncate px-2 text-xs text-steel" data-testid="crm-user-email">{email}</p>
          <div className="mt-2 flex gap-2">
            <Link to="/admin/tableau-de-bord" data-testid="crm-link-admin"
              className="flex-1 rounded-full border border-line px-3 py-2 text-center text-xs font-semibold text-graphite transition-colors hover:text-electric">
              Admin
            </Link>
            <button onClick={logout} data-testid="crm-logout-button"
              className="flex-1 rounded-full bg-navy-800 px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-navy-900">
              Déconnexion
            </button>
          </div>
        </div>
      </aside>
      <main className="ml-64 flex-1 p-8">
        <Outlet context={{ email }} />
      </main>
    </div>
  );
}
